<template>
  <div class="product-info-wrapper">
    <div class="banner">
      <div class="cover cover-wp">
        <div class="cover-text">
          <h4>屋畔</h4>
          <!-- <p class="info">
            提供综合性社区服务集中解决方案，在涵盖多种智能开门方式的基础上，结合独有的线上线下运营模式，将多种场景的便民惠民服务融合于社区统一场景下，旨在建设更为美好的社区生活，形成合力向善的新生态环境。
          </p> -->
          <p class="info">屋畔社区服务产品，以服务为核心，为政府、商户（服务组织）以及居民提供综合性社区服务。PC端和移动端，高效适配不同场景和用户，包含政府管理、运营管理和服务管理。屋畔深挖社区场景数据价值，纵向打通政府-居民管理链路，在进行日常管理的同时，进行政务服务输送；横向打通商户（服务组织）—居民服务链条，为居民准确推送便民服务，提升生活品质。</p>
        </div>
      </div>
    </div>
    <!-- 产品功能 -->
    <div class="product-function">
      <div class="common-title">
        <div class="common-title-content">
          产品功能
        </div>
      </div>
      <div class="product-function-list">
        <div class="item" style='text-align: center;' v-for="(item, index) in funcList[targItem]" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
      <div class="list_tog">
          <el-radio-group v-model="targItem">
            <el-radio-button class="btn" label="0">运营服务</el-radio-button>
            <el-radio-button class="btn" label="1">政府服务</el-radio-button>
            <el-radio-button class="btn" label="2">居民服务</el-radio-button>
          </el-radio-group>
        </div>
    </div>
    <!-- 产品优势 -->
    <div class="product-advantage product-advantage-blue bg2F61AE">
      <div class="common-title">
        <div class="common-title-content">
          产品优势
        </div>
      </div>
      <div class="content content-blue">
        <div class="circle">
          <div class="badge">
            <img src="@/assets/images/productInfo/wp/badge.png" />
          </div>
          <div class="feature feature-one">
            <div class="text">社区服务精准触达</div>
          </div>
          <div class="feature feature-two">
            <div class="text">组织管理规范精细</div>
          </div>
          <div class="feature feature-three">
            <div class="text">工作处置协同高效</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <div class="product-application-scene">
      <div class="common-title">
        <div class="common-title-content">
          应用场景
        </div>
      </div>
      <div class="product-scene-list">
        <div class="item" v-for="(item, index) in sceneList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text" v-html="item.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "wp",
  data() {
    return {
      targItem: '1',
      funcList: [
        [
          {
            imgUrl: require("@/assets/images/productInfo/wp/yyfw/ico_xsgzgl.png"),
            text: "线上工作管理"
          },
          {
            imgUrl: require("@/assets/images/productInfo/wp/yyfw/ico_xsfwgl.png"),
            text: "线上服务管理"
          },
          {
            imgUrl: require("@/assets/images/productInfo/wp/yyfw/ico_lsfwcx.png"),
            text: "历史服务查询"
          },
          {
            imgUrl: require("@/assets/images/productInfo/wp/yyfw/ico_jftxdj.png"),
            text: "积分体系搭建"
          },
          {
            imgUrl: require("@/assets/images/productInfo/wp/yyfw/ico_hmhdgl.png"),
            text: "惠民活动管理"
          }
        ],
        [     
          {
            imgUrl: require("@/assets/images/productInfo/wp/zffw/ico_jcxxcj.png"),
            text: "基础信息采集"
          },
          {
            imgUrl: require("@/assets/images/productInfo/wp/zffw/ico_msyjcj.png"),
            text: "民生意见采集"
          },
          {
            imgUrl: require("@/assets/images/productInfo/wp/zffw/ico_fwzzgl.png"),
            text: "服务组织管理"
          },
          {
            imgUrl: require("@/assets/images/productInfo/wp/zffw/ico_zyzzm.png"),
            text: "志愿者招募"
          },
          {
            imgUrl: require("@/assets/images/productInfo/wp/zffw/ico_hdfczs.png"),
            text: "活动风采展示"
          }
        ],
        [
          {
            imgUrl: require("@/assets/images/productInfo/wp/jmfw/ico_zyhdsq.png"),
            text: "志愿活动申请"
          },
          {
            imgUrl: require("@/assets/images/productInfo/wp/jmfw/ico_gxkjyy.png"),
            text: "共享空间预约"
          },
          {
            imgUrl: require("@/assets/images/productInfo/wp/jmfw/ico_zbshhq.png"),
            text: "周边商户获取"
          },
          {
            imgUrl: require("@/assets/images/productInfo/wp/jmfw/ico_zbyhhq.png"),
            text: "周边优惠获取"
          },
          {
            imgUrl: require("@/assets/images/productInfo/wp/jmfw/ico_lnhzfw.png"),
            text: "邻里互助服务"
          }
        ]
      ],
      funcList1: [
        {
          imgUrl: require("@/assets/images/productInfo/wp/ico_znmj.png"),
          text: "智能门禁"
        },
        {
          imgUrl: require("@/assets/images/productInfo/wp/ico_wyfw.png"),
          text: "物业服务"
        },
        {
          imgUrl: require("@/assets/images/productInfo/wp/ico_dzzw.png"),
          text: "电子政务"
        },
        {
          imgUrl: require("@/assets/images/productInfo/wp/ico_sqhd.png"),
          text: "社区活动"
        }
      ],
      sceneList: [
        {
          imgUrl: require("@/assets/images/productInfo/wp/jmfw.png"),
          text: "居民服务"
        },
        {
          imgUrl: require("@/assets/images/productInfo/wp/yygl.png"),
          text: "运营管理"
        },
        {
          imgUrl: require("@/assets/images/productInfo/wp/zzgl.png"),
          text: "组织管理"
        },
        {
          imgUrl: require("@/assets/images/productInfo/wp/bdsj.png"),
          text: "本地社交"
        }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
  .list_tog{
    // display: flex;
    // justify-content: space-between;
    padding-top: 3.5rem;
    text-align: center;
    .btn{
      // width: 20.2rem;
      // height: 3.6rem;
      width: 24rem;
      border-right: 1px solid #E6E6E6;
    }
    & /deep/ .el-radio-button__inner{
      border: none;
      // height: 100%;
      width: 100%;
      font-size: 1.2rem;
      line-height: 3.8rem;
      height: 3.8rem;
      padding: 0;
      background: #2F61AE;
      color: #FFF;
    }
    & /deep/ .is-active{
      background: #E6E6E6;
      // color: #999;
      span{
        // color: #2F61AE;
        color: #333;
        background: #E6E6E6;
      }
    }
  }
</style>
